module.exports = __webpack_public_path__ + "img/call.6aeb7927.png";